<p-dialog header="{{ 'WarehousingAbnormal.Modal.AbnormalHistory' | translate }}" appendTo="body" [(visible)]="isVisible"
  [modal]="true" [draggable]="false" [resizable]="false" (visibleChange)="dialogVisibleChange($event)"
  [style]="{ width: '50%' }">
  <p-table [columns]="warehousingHeaderHistoryColumns" [value]="warehousingHeaderHistoryResults">
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th *ngFor="let col of columns">
          {{col.header | translate}}
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-columns="columns">
      <tr>
        <td *ngFor="let col of columns">
          <ng-container [ngSwitch]="col.field">
            <ng-container *ngSwitchCase="'notifyDt'">
              <div class="overflow-text">{{ rowData[col.field] | date:'yyyy-MM-dd
                HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}</div>
            </ng-container>
            <ng-container *ngSwitchCase="'handleDt'">
              <div class="overflow-text">{{ rowData[col.field] | date:'yyyy-MM-dd
                HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}</div>
            </ng-container>
            <ng-container *ngSwitchCase="'abnormalType'">
              <div class="overflow-text">{{ rowData[col.field] | optionsMapping:abnormalTypeOptions |
                replaceNullWith:'-' }}</div>
            </ng-container>
            <ng-container *ngSwitchDefault>
              <div class="overflow-text">
                {{ rowData[col.field] | replaceNullWith:'-'}}
              </div>
            </ng-container>
          </ng-container>
        </td>
      </tr>
    </ng-template>
  </p-table>
</p-dialog>